function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../core-video-internal';
import { sdkLogger } from '../../logger';
import { createLoggingObservable } from '../../utils/observables/verbose-logging-observable';
export var SessionControllerInternalProxy = /*#__PURE__*/ function() {
    "use strict";
    function SessionControllerInternalProxy() {
        _class_call_check(this, SessionControllerInternalProxy);
        _define_property(this, "eventTransformersToRegister", {
            onStateChanged: [],
            onError: [],
            onSessionEnded: []
        });
        _define_property(this, "sessionControllerInternal", void 0);
        _define_property(this, "logger", sdkLogger.withContext('SCIP'));
        _define_property(this, "adBreakDataReceivedObservable", createLoggingObservable('AdBreakDataReceived', this.logger));
        _define_property(this, "adTrackingReceivedObservable", createLoggingObservable('AdTrackingReceived', this.logger));
        _define_property(this, "adBreakStartedObservable", createLoggingObservable('AdBreakStarted', this.logger));
        _define_property(this, "adBreakFinishedObservable", createLoggingObservable('AdBreakFinished', this.logger));
        _define_property(this, "adStartedObservable", createLoggingObservable('AdStarted', this.logger));
        _define_property(this, "adFinishedObservable", createLoggingObservable('AdFinished', this.logger));
        _define_property(this, "adPositionObservable", createLoggingObservable('AdPositionChanged', this.logger));
        _define_property(this, "catchupSeekObservable", createLoggingObservable('CatchupSeek', this.logger));
        _define_property(this, "sessionStateObservable", createLoggingObservable('SessionState', this.logger));
        _define_property(this, "rebufferStartObservable", createLoggingObservable('BufferingStarted', this.logger));
        _define_property(this, "rebufferEndObservable", createLoggingObservable('BufferingEnded', this.logger));
        _define_property(this, "errorObservable", createLoggingObservable('Error', this.logger));
        _define_property(this, "manifestReceivedObservable", createLoggingObservable('ManifestReceived', this.logger));
        _define_property(this, "isMutedObservable", createLoggingObservable('MuteChanged', this.logger));
        _define_property(this, "playStartObservable", createLoggingObservable('PlayStart', this.logger));
        _define_property(this, "seekStartedObservable", createLoggingObservable('SeekStarted', this.logger));
        _define_property(this, "seekEndedObservable", createLoggingObservable('SeekEnded', this.logger));
        _define_property(this, "timedMetadataReceivedObservable", createLoggingObservable('TimedMetadataReceived', this.logger));
        _define_property(this, "bulkTimedMetadataReceivedObservable", createLoggingObservable('BulkTimedMetadataReceived', this.logger));
        _define_property(this, "playbackTimelineObservable", createLoggingObservable('PlaybackTimelineUpdated', this.logger));
        _define_property(this, "audioTrackWillChangeObservable", createLoggingObservable('AudioTrackWillChange', this.logger));
        _define_property(this, "bitrateChangedObservable", createLoggingObservable('BitrateChanged', this.logger));
        _define_property(this, "encodedFrameRateChangedObservable", createLoggingObservable('EncodedFrameRateChanged', this.logger));
        _define_property(this, "renderedFrameRateChangedObservable", createLoggingObservable('RenderedFrameRateChanged', this.logger));
        _define_property(this, "videoTrackChangedObservable", createLoggingObservable('VideoTrackChanged', this.logger));
        _define_property(this, "qualityFailoverObservable", createLoggingObservable('QualityFailover', this.logger));
        _define_property(this, "cdnSwitchObservable", createLoggingObservable('CdnSwitch', this.logger));
        _define_property(this, "warningObservable", createLoggingObservable('Warning', this.logger));
        _define_property(this, "pinRequiredObservable", createLoggingObservable('PinRequired', this.logger));
        _define_property(this, "pinSuccessObservable", createLoggingObservable('PinSuccess', this.logger));
        _define_property(this, "autoPlayPolicyPreventedPlaybackObservable", createLoggingObservable('AutoPlayPolicyPreventedPlayback', this.logger));
        _define_property(this, "assetMetadataUpdateObservable", createLoggingObservable('AssetMetadata', this.logger));
        _define_property(this, "playoutDataObservable", createLoggingObservable('PlayoutDataReceived', this.logger));
        _define_property(this, "playoutRulesObservable", createLoggingObservable('PlayoutRulesReceived', this.logger));
        _define_property(this, "audioTrackChangedObservable", createLoggingObservable('AudioTrackChanged', this.logger));
        _define_property(this, "bitrateCapChangedObservable", createLoggingObservable('BitrateCapChanged', this.logger));
        _define_property(this, "bitrateCapRequestedObservable", createLoggingObservable('BitrateCapChanged', this.logger));
        _define_property(this, "ituQaSessionDataObservable", createLoggingObservable('ItuQaSessionData', this.logger));
        _define_property(this, "availableAudioTracksChangedObservable", createLoggingObservable('AvailableAudioTracksChanged', this.logger));
        _define_property(this, "telemetryObservable", createLoggingObservable('TelemetryEvent', this.logger));
        _define_property(this, "availableSubtitlesTracksChangedObservable", createLoggingObservable('AvailableSubtitlesTracksChanged', this.logger));
        _define_property(this, "streamMetadataReceivedObservable", createLoggingObservable('StreamMetadataReceived', this.logger));
        _define_property(this, "subtitlesTrackChangedObservable", createLoggingObservable('SubtitlesTrackChanged', this.logger));
        _define_property(this, "subtitleCuesChangedObservable", createLoggingObservable('SubtitleCuesChanged', this.logger));
        _define_property(this, "volumeChangedObservable", createLoggingObservable('VolumeChanged', this.logger));
        _define_property(this, "eventBoundaryObservable", createLoggingObservable('EventBoundary', this.logger));
        _define_property(this, "sessionEndedObservable", createLoggingObservable('SessionEnded', this.logger));
        _define_property(this, "videoElementCreatedObservable", createLoggingObservable('VideoElementCreated', this.logger));
        _define_property(this, "fullscreenChangedObservable", createLoggingObservable('FullscreenChanged', this.logger));
        _define_property(this, "clickedObservable", createLoggingObservable('Clicked', this.logger));
        _define_property(this, "availableThumbnailVariantsChangedObservable", createLoggingObservable('AvailableThumbnailVariantsChanged', this.logger));
        _define_property(this, "telemetryUpdateObservable", createLoggingObservable('telemetryUpdateObservable', this.logger));
        _define_property(this, "endOfEventMarkerReceivedObservable", createLoggingObservable('EndOfEventMarkerReceived', this.logger));
        _define_property(this, "pauseAdObservable", createLoggingObservable('PauseAd', this.logger));
        _define_property(this, "companionAdInsertionEnabledObservable", createLoggingObservable('CompanionAdInsertionEnabled', this.logger));
        _define_property(this, "companionAdOpportunityStartedObservable", createLoggingObservable('CompanionAdOpportunityStarted', this.logger));
        _define_property(this, "companionAdOpportunityEndedObservable", createLoggingObservable('CompanionAdOpportunityEnded', this.logger));
        _define_property(this, "renderWatermarkObservable", createLoggingObservable('RenderWatermark', this.logger));
        _define_property(this, "clearWatermarkObservable", createLoggingObservable('ClearWatermark', this.logger));
        _define_property(this, "clearWatermarksObservable", createLoggingObservable('ClearWatermarks', this.logger));
        _define_property(this, "cachedAdBreaks", null);
        _define_property(this, "warnings", []);
        _define_property(this, "waitForStatePendingResolvers", []);
        _define_property(this, "sessionStarted", false);
        _define_property(this, "sessionRetryStartedObservable", createLoggingObservable('SessionRetryStarted', this.logger));
        _define_property(this, "sessionRetryEndedObservable", createLoggingObservable('SessionRetryEnded', this.logger));
        _define_property(this, "sessionRestartStartedObservable", createLoggingObservable('SessionRestartStarted', this.logger));
        _define_property(this, "sessionRestartEndedObservable", createLoggingObservable('SessionRestartEnded', this.logger));
        _define_property(this, "httpRequestObservable", createLoggingObservable('HttpRequestEvent', this.logger));
        _define_property(this, "httpResponseObservable", createLoggingObservable('HttpResponseEvent', this.logger));
    }
    _create_class(SessionControllerInternalProxy, [
        {
            key: "setEventTransformers",
            value: // Create a wrapper for the observable that is able to transform instead of having it in every observable
            function setEventTransformers(eventTransformers) {
                if (eventTransformers.onStateChanged && eventTransformers.onStateChanged.length > 0) {
                    var _this_eventTransformersToRegister_onStateChanged;
                    (_this_eventTransformersToRegister_onStateChanged = this.eventTransformersToRegister.onStateChanged).push.apply(_this_eventTransformersToRegister_onStateChanged, _to_consumable_array(eventTransformers.onStateChanged));
                }
                if (eventTransformers.onError && eventTransformers.onError.length > 0) {
                    var _this_eventTransformersToRegister_onError;
                    (_this_eventTransformersToRegister_onError = this.eventTransformersToRegister.onError).push.apply(_this_eventTransformersToRegister_onError, _to_consumable_array(eventTransformers.onError));
                }
                if (eventTransformers.onSessionEnded && eventTransformers.onSessionEnded.length > 0) {
                    var _this_eventTransformersToRegister_onSessionEnded;
                    (_this_eventTransformersToRegister_onSessionEnded = this.eventTransformersToRegister.onSessionEnded).push.apply(_this_eventTransformersToRegister_onSessionEnded, _to_consumable_array(eventTransformers.onSessionEnded));
                }
            }
        },
        {
            key: "notifySessionRetryStarted",
            value: function notifySessionRetryStarted(error) {
                this.sessionRetryStartedObservable.notifyObservers(error);
            }
        },
        {
            key: "getNumVpfRetryAttempts",
            value: function getNumVpfRetryAttempts() {
                return this.sessionRetryStartedObservable.getNumTimesNotified();
            }
        },
        {
            key: "notifySessionRetryEnded",
            value: function notifySessionRetryEnded(error) {
                this.sessionRetryEndedObservable.notifyObservers(error);
            }
        },
        {
            key: "notifySessionRestartStarted",
            value: function notifySessionRestartStarted() {
                this.sessionRestartStartedObservable.notifyObservers();
            }
        },
        {
            key: "notifySessionRestartEnded",
            value: function notifySessionRestartEnded() {
                this.sessionRestartEndedObservable.notifyObservers();
            }
        },
        {
            key: "notifyItuQaSessionData",
            value: function notifyItuQaSessionData(ituQaSessionData) {
                this.ituQaSessionDataObservable.notifyObservers(ituQaSessionData);
            }
        },
        {
            key: "notifySessionEnded",
            value: function notifySessionEnded() {
                this.sessionEndedObservable.notifyObservers();
                this.sessionEndedObservable.unregisterObservers(this);
            }
        },
        {
            key: "notifyAdBreakDataReceived",
            value: function notifyAdBreakDataReceived(adBreaks) {
                if (this.sessionControllerInternal && this.sessionStarted) {
                    this.sessionControllerInternal.notifyAdBreakDataReceived(adBreaks);
                } else {
                    this.cachedAdBreaks = adBreaks;
                }
            }
        },
        {
            key: "notifyAdTrackingReceived",
            value: function notifyAdTrackingReceived(adBreaks) {
                if (this.sessionControllerInternal && this.sessionStarted) {
                    this.sessionControllerInternal.notifyAdTrackingReceived(adBreaks);
                }
            }
        },
        {
            key: "notifyCatchupSeek",
            value: function notifyCatchupSeek(catchupSeek) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyCatchupSeek(catchupSeek);
            }
        },
        {
            key: "getCurrentState",
            value: function getCurrentState() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getCurrentState();
            }
        },
        {
            key: "getAdvertsManager",
            value: function getAdvertsManager() {
                var _this_sessionControllerInternal;
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getAdvertsManager();
            }
        },
        {
            key: "notifyAdBreakFinished",
            value: function notifyAdBreakFinished(adBreak) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyAdBreakFinished(adBreak);
            }
        },
        {
            key: "notifyAdBreakStarted",
            value: function notifyAdBreakStarted(adBreak) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyAdBreakStarted(adBreak);
            }
        },
        {
            key: "notifyAdFinished",
            value: function notifyAdFinished(adData) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyAdFinished(adData);
            }
        },
        {
            key: "notifyAdPositionChanged",
            value: function notifyAdPositionChanged(adPosition) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyAdPositionChanged(adPosition);
            }
        },
        {
            key: "notifyTelemetry",
            value: function notifyTelemetry(telemetryEvent) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyTelemetry(telemetryEvent);
            }
        },
        {
            key: "getContentTimePosition",
            value: function getContentTimePosition() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getContentTimePosition();
            }
        },
        {
            key: "notifyAdStarted",
            value: function notifyAdStarted(adData) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyAdStarted(adData);
            }
        },
        {
            key: "notifyPauseAd",
            value: function notifyPauseAd(ad) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyPauseAd(ad);
            }
        },
        {
            key: "notifyCompanionAdInsertionEnabled",
            value: function notifyCompanionAdInsertionEnabled(companionAdInsertionEnabled) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyCompanionAdInsertionEnabled(companionAdInsertionEnabled);
            }
        },
        {
            key: "notifyCompanionAdOpportunityStarted",
            value: function notifyCompanionAdOpportunityStarted(ad) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyCompanionAdOpportunityStarted(ad);
            }
        },
        {
            key: "notifyCompanionAdOpportunityEnded",
            value: function notifyCompanionAdOpportunityEnded(ad) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyCompanionAdOpportunityEnded(ad);
            }
        },
        {
            key: "notifyTimelineAssetsAvailable",
            value: function notifyTimelineAssetsAvailable(assetGroups) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyTimelineAssetsAvailable(assetGroups);
            }
        },
        {
            key: "notifyWarning",
            value: function notifyWarning(errorCode, reason) {
                if (this.sessionControllerInternal && this.sessionStarted) {
                    this.flushStoredWarnings();
                    this.sessionControllerInternal.notifyWarning(errorCode, reason);
                } else {
                    if (!this.warnings) {
                        this.warnings = [];
                    }
                    this.warnings.push({
                        errorCode: errorCode,
                        reason: reason
                    });
                }
            }
        },
        {
            key: "notifyRebufferStart",
            value: function notifyRebufferStart() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyRebufferStart();
            }
        },
        {
            key: "notifyRebufferEnd",
            value: function notifyRebufferEnd() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyRebufferEnd();
            }
        },
        {
            key: "onStreamMetadataReceived",
            value: function onStreamMetadataReceived(callback) {
                this.streamMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSubtitlesTrackChanged",
            value: function onSubtitlesTrackChanged(callback) {
                this.subtitlesTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSubtitleCuesChanged",
            value: function onSubtitleCuesChanged(callback) {
                this.subtitleCuesChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVolumeChanged",
            value: function onVolumeChanged(callback) {
                this.volumeChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEventBoundary",
            value: function onEventBoundary(callback) {
                this.eventBoundaryObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAudioTrackChanged",
            value: function onAudioTrackChanged(callback) {
                this.audioTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateCapChanged",
            value: function onBitrateCapChanged(callback) {
                this.bitrateCapChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateCapRequested",
            value: function onBitrateCapRequested(callback) {
                this.bitrateCapRequestedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onItuQaSessionData",
            value: function onItuQaSessionData(callback) {
                this.ituQaSessionDataObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableAudioTracksChanged",
            value: function onAvailableAudioTracksChanged(callback) {
                return this.availableAudioTracksChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableThumbnailVariantsChanged",
            value: function onAvailableThumbnailVariantsChanged(callback) {
                this.availableThumbnailVariantsChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTelemetry",
            value: function onTelemetry(callback) {
                this.telemetryObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTelemetryUpdate",
            value: function onTelemetryUpdate(callback) {
                this.telemetryUpdateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "updateTelemetryMetrics",
            value: function updateTelemetryMetrics(telemetryUpdate) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.updateTelemetryMetrics(telemetryUpdate);
            }
        },
        {
            key: "onHttpRequest",
            value: function onHttpRequest(callback) {
                this.httpRequestObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onHttpResponse",
            value: function onHttpResponse(callback) {
                this.httpResponseObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEndOfEventMarkerReceived",
            value: function onEndOfEventMarkerReceived(callback) {
                this.endOfEventMarkerReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableSubtitlesTracksChanged",
            value: function onAvailableSubtitlesTracksChanged(callback) {
                return this.availableSubtitlesTracksChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionEnded",
            value: function onSessionEnded(callback) {
                this.sessionEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPinRequired",
            value: function onPinRequired(callback) {
                this.pinRequiredObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPinSuccess",
            value: function onPinSuccess(callback) {
                this.pinSuccessObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAutoPlayPolicyPreventedPlayback",
            value: function onAutoPlayPolicyPreventedPlayback(callback) {
                this.autoPlayPolicyPreventedPlaybackObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayoutDataReceived",
            value: function onPlayoutDataReceived(callback) {
                this.playoutDataObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayoutRulesReceived",
            value: function onPlayoutRulesReceived(callback) {
                this.playoutRulesObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAssetMetadataUpdated",
            value: function onAssetMetadataUpdated(callback) {
                this.assetMetadataUpdateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAudioTrackWillChange",
            value: function onAudioTrackWillChange(callback) {
                this.audioTrackWillChangeObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPauseAd",
            value: function onPauseAd(callback) {
                this.pauseAdObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVerifyCompanionAdInsertionEnabled",
            value: function onVerifyCompanionAdInsertionEnabled(callback) {
                this.companionAdInsertionEnabledObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCompanionAdOpportunityStarted",
            value: function onCompanionAdOpportunityStarted(callback) {
                this.companionAdOpportunityStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCompanionAdOpportunityEnded",
            value: function onCompanionAdOpportunityEnded(callback) {
                this.companionAdOpportunityEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRenderWatermark",
            value: function onRenderWatermark(callback) {
                this.renderWatermarkObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClearWatermark",
            value: function onClearWatermark(callback) {
                this.clearWatermarkObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClearWatermarks",
            value: function onClearWatermarks(callback) {
                this.clearWatermarksObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateChanged",
            value: function onBitrateChanged(callback) {
                this.bitrateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEncodedFrameRateChanged",
            value: function onEncodedFrameRateChanged(callback) {
                this.encodedFrameRateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRenderedFrameRateChanged",
            value: function onRenderedFrameRateChanged(callback) {
                this.renderedFrameRateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVideoTrackChanged",
            value: function onVideoTrackChanged(callback) {
                this.videoTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onQualityFailover",
            value: function onQualityFailover(callback) {
                this.qualityFailoverObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCdnSwitch",
            value: function onCdnSwitch(callback) {
                this.cdnSwitchObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onWarning",
            value: function onWarning(callback) {
                this.warningObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakStarted",
            value: function onAdBreakStarted(callback) {
                this.adBreakStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakFinished",
            value: function onAdBreakFinished(callback) {
                this.adBreakFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdStarted",
            value: function onAdStarted(callback) {
                this.adStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdFinished",
            value: function onAdFinished(callback) {
                this.adFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakDataReceived",
            value: function onAdBreakDataReceived(callback) {
                this.adBreakDataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdTrackingReceived",
            value: function onAdTrackingReceived(callback) {
                this.adTrackingReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCatchupSeek",
            value: function onCatchupSeek(callback) {
                this.catchupSeekObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdPositionChanged",
            value: function onAdPositionChanged(callback) {
                this.adPositionObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onError",
            value: function onError(callback) {
                this.errorObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onManifestReceived",
            value: function onManifestReceived(callback) {
                this.manifestReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onMuteChanged",
            value: function onMuteChanged(callback) {
                this.isMutedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSeekEnded",
            value: function onSeekEnded(callback) {
                this.seekEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSeekStarted",
            value: function onSeekStarted(callback) {
                this.seekStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayStart",
            value: function onPlayStart(callback) {
                this.playStartObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onStateChanged",
            value: function onStateChanged(callback, priority) {
                this.sessionStateObservable.registerObserver(callback, this, {
                    priority: priority
                });
            }
        },
        {
            key: "onRebufferStart",
            value: function onRebufferStart(callback) {
                var _this_rebufferStartObservable;
                (_this_rebufferStartObservable = this.rebufferStartObservable) === null || _this_rebufferStartObservable === void 0 ? void 0 : _this_rebufferStartObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRebufferEnd",
            value: function onRebufferEnd(callback) {
                var _this_rebufferEndObservable;
                (_this_rebufferEndObservable = this.rebufferEndObservable) === null || _this_rebufferEndObservable === void 0 ? void 0 : _this_rebufferEndObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRetryStarted",
            value: function onSessionRetryStarted(callback) {
                this.sessionRetryStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRetryEnded",
            value: function onSessionRetryEnded(callback) {
                this.sessionRetryEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRestartStarted",
            value: function onSessionRestartStarted(callback) {
                this.sessionRestartStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRestartEnded",
            value: function onSessionRestartEnded(callback) {
                this.sessionRestartEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTimedMetadataReceived",
            value: function onTimedMetadataReceived(callback) {
                return this.timedMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBulkTimedMetadataReceived",
            value: function onBulkTimedMetadataReceived(callback) {
                this.bulkTimedMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlaybackTimelineUpdated",
            value: function onPlaybackTimelineUpdated(callback) {
                this.playbackTimelineObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVideoElementCreated",
            value: function onVideoElementCreated(callback) {
                this.videoElementCreatedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onFullscreenChanged",
            value: function onFullscreenChanged(callback) {
                this.fullscreenChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClicked",
            value: function onClicked(callback) {
                this.clickedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onUserWaitStarted",
            value: function onUserWaitStarted(callback) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.onUserWaitStarted(callback);
            }
        },
        {
            key: "onUserWaitEnded",
            value: function onUserWaitEnded(callback) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.onUserWaitEnded(callback);
            }
        },
        {
            key: "handleSessionStarted",
            value: function handleSessionStarted() {
                this.sessionStarted = true;
                this.flushStoredAdBreaks();
                this.flushStoredWarnings();
            }
        },
        {
            key: "registerCue",
            value: function registerCue(cue) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                var id = (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.registerCue(cue);
                return id !== null && id !== void 0 ? id : '';
            }
        },
        {
            key: "unregisterCue",
            value: function unregisterCue(cueId) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                var cueFound = (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.unregisterCue(cueId);
                return cueFound !== null && cueFound !== void 0 ? cueFound : false;
            }
        },
        {
            key: "onEventCueEntered",
            value: function onEventCueEntered(type, callback) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.onEventCueEntered(type, callback);
            }
        },
        {
            key: "onCueUpdated",
            value: function onCueUpdated(type, callback) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.onEventCueUpdated(type, callback);
            }
        },
        {
            key: "onEventCueExited",
            value: function onEventCueExited(type, callback) {
                this.warnIfNoSession();
                return this.sessionControllerInternal.onEventCueExited(type, callback);
            }
        },
        {
            key: "onEventCueRegistered",
            value: function onEventCueRegistered(type, callback) {
                this.warnIfNoSession();
                return this.sessionControllerInternal.onEventCueRegistered(type, callback);
            }
        },
        {
            key: "onEventCueUnregistered",
            value: function onEventCueUnregistered(type, callback) {
                this.warnIfNoSession();
                return this.sessionControllerInternal.onEventCueUnregistered(type, callback);
            }
        },
        {
            key: "attachSession",
            value: function attachSession(sessionController) {
                this.sessionControllerInternal = sessionController;
                this.attachWaitForStateResolvers();
                this.attachSessionEvents();
                sessionController.setEventTransformers(this.eventTransformersToRegister);
            }
        },
        {
            key: "getProposition",
            value: function getProposition() {
                return CoreVideoInternal.config.staticConfig.proposition;
            }
        },
        {
            key: "playerVersion",
            get: function get() {
                return CoreVideoInternal.playerVersion;
            }
        },
        {
            key: "getPrecursor",
            value: function getPrecursor() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getPrecursor();
            }
        },
        {
            key: "getPrefetchStage",
            value: function getPrefetchStage() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getPrefetchStage();
            }
        },
        {
            key: "isPrefetchedSession",
            value: function isPrefetchedSession() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return Boolean((_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.isPrefetchedSession());
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.start()
                        ];
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.stop()
                        ];
                    });
                })();
            }
        },
        {
            key: "play",
            value: function play() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.pause();
            }
        },
        {
            key: "seekToDate",
            value: function seekToDate(seekDate) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.seekToDate(seekDate)
                        ];
                    });
                })();
            }
        },
        {
            key: "seek",
            value: function seek(contentTime) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.seek(contentTime);
            }
        },
        {
            key: "seekToLiveEdge",
            value: function seekToLiveEdge() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.seekToLiveEdge()
                        ];
                    });
                })();
            }
        },
        {
            key: "seekToLiveStart",
            value: function seekToLiveStart() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.seekToLiveStart()
                        ];
                    });
                })();
            }
        },
        {
            key: "isAtLiveEdge",
            value: function isAtLiveEdge() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            Boolean((_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.isAtLiveEdge())
                        ];
                    });
                })();
            }
        },
        {
            key: "isLinearScrubbingSupported",
            value: function isLinearScrubbingSupported() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return Boolean((_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.isLinearScrubbingSupported());
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setVolume(volume);
            }
        },
        {
            key: "setMute",
            value: function setMute(isMuted) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setMute(isMuted);
            }
        },
        {
            key: "setPlayerBitrateLimits",
            value: function setPlayerBitrateLimits(playerBitrateLimits) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setPlayerBitrateLimits(playerBitrateLimits);
            }
        },
        {
            key: "getMaxVideoFormat",
            value: function getMaxVideoFormat() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getMaxVideoFormat();
            }
        },
        {
            key: "getSupportedColourSpaces",
            value: function getSupportedColourSpaces() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getSupportedColourSpaces();
            }
        },
        {
            key: "getSupportedAudioFormats",
            value: function getSupportedAudioFormats() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getSupportedAudioFormats();
            }
        },
        {
            key: "getSupportedMaxHdcpLevel",
            value: function getSupportedMaxHdcpLevel() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getSupportedMaxHdcpLevel();
            }
        },
        {
            key: "getConnectedHdcpLevel",
            value: function getConnectedHdcpLevel() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getConnectedHdcpLevel();
            }
        },
        {
            key: "getWidevineSecurityLevel",
            value: function getWidevineSecurityLevel() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getWidevineSecurityLevel();
            }
        },
        {
            key: "getSupportedVideoCodecs",
            value: function getSupportedVideoCodecs() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getSupportedVideoCodecs();
            }
        },
        {
            key: "resetPlayerBitrateLimits",
            value: function resetPlayerBitrateLimits() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.resetPlayerBitrateLimits();
            }
        },
        {
            key: "enableSubtitles",
            value: function enableSubtitles(trackId) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.enableSubtitles(trackId);
            }
        },
        {
            key: "disableSubtitles",
            value: function disableSubtitles() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.disableSubtitles();
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(trackId) {
                var _this_sessionControllerInternal, _this;
                this.warnIfNoSession();
                return (_this = this) === null || _this === void 0 ? void 0 : (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setAudioTrack(trackId);
            }
        },
        {
            key: "setUserWaitStarted",
            value: function setUserWaitStarted() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setUserWaitStarted();
            }
        },
        {
            key: "setUserWaitEnded",
            value: function setUserWaitEnded() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setUserWaitEnded();
            }
        },
        {
            key: "waitForState",
            value: function waitForState(state) {
                var _this = this;
                this.warnIfNoSession();
                if (this.sessionControllerInternal) {
                    return this.sessionControllerInternal.waitForState(state);
                } else {
                    return new Promise(function(resolve) {
                        _this.waitForStatePendingResolvers.push({
                            state: state,
                            resolver: resolve
                        });
                    });
                }
            }
        },
        {
            key: "waitForOneOfStates",
            value: function waitForOneOfStates(states) {
                this.warnIfNoSession();
                if (this.sessionControllerInternal) {
                    return this.sessionControllerInternal.waitForOneOfStates(states);
                }
                return Promise.resolve();
            }
        },
        {
            key: "requestSessionStop",
            value: function requestSessionStop(error) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.requestSessionStop(error)
                        ];
                    });
                })();
            }
        },
        {
            key: "isFinished",
            value: function isFinished() {
                this.warnIfNoSession();
                if (this.sessionControllerInternal) {
                    return Boolean(this.sessionControllerInternal.isFinished());
                }
                return true;
            }
        },
        {
            key: "restartSession",
            value: function restartSession() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.restartSession();
            }
        },
        {
            key: "retrySession",
            value: function retrySession() {
                // Added here for type safety. Implemented in the Chromecast sender session controller only
                this.logger.warn("Method 'retrySession' is not implemented");
            }
        },
        {
            key: "isBlockingUserInput",
            value: function isBlockingUserInput() {
                this.warnIfNoSession();
                if (this.sessionControllerInternal) {
                    return Boolean(this.sessionControllerInternal.isBlockingUserInput());
                }
                return true;
            }
        },
        {
            key: "cancelPin",
            value: function cancelPin() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.cancelPin();
            }
        },
        {
            key: "setPin",
            value: function setPin(pin) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        _this.pinRequiredObservable.reset();
                        return [
                            2,
                            (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setPin(pin)
                        ];
                    });
                })();
            }
        },
        {
            key: "setThumbnailVariant",
            value: function setThumbnailVariant(variantId) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                if ((_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.setThumbnailVariant) {
                    return this.sessionControllerInternal.setThumbnailVariant(variantId);
                }
                return Promise.resolve(undefined);
            }
        },
        {
            key: "getThumbnailForTime",
            value: function getThumbnailForTime(contentTime, velocitySecondsPerSecond) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        if (!_this.sessionControllerInternal) {
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            _this.sessionControllerInternal.getThumbnailForTime(contentTime, velocitySecondsPerSecond)
                        ];
                    });
                })();
            }
        },
        {
            key: "isSeekToDateSupported",
            value: function isSeekToDateSupported() {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return Boolean((_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.isSeekToDateSupported());
            }
        },
        {
            key: "getLiveWindow",
            value: function getLiveWindow() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionControllerInternal;
                    return _ts_generator(this, function(_state) {
                        _this.warnIfNoSession();
                        return [
                            2,
                            ((_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.getLiveWindow()) || null
                        ];
                    });
                })();
            }
        },
        {
            key: "notifyAssetMetadataUpdated",
            value: function notifyAssetMetadataUpdated(assetMetadata) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyAssetMetadataUpdated(assetMetadata);
            }
        },
        {
            key: "notifyEventBoundary",
            value: function notifyEventBoundary(event) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyEventBoundary(event);
            }
        },
        {
            key: "notifyEndOfEventMarkerReceived",
            value: function notifyEndOfEventMarkerReceived(eventTime) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyEndOfEventMarkerReceived(eventTime);
            }
        },
        {
            key: "notifyStreamMetadataReceived",
            value: function notifyStreamMetadataReceived(metadata) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyStreamMetadataReceived(metadata);
            }
        },
        {
            key: "notifyError",
            value: function notifyError(error) {
                var _this_sessionControllerInternal;
                this.warnIfNoSession();
                return (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyError(error);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeEventListeners();
                this.videoElementCreatedObservable.reset();
                this.sessionControllerInternal = undefined;
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                this.streamMetadataReceivedObservable.unregisterObservers(this);
                this.subtitlesTrackChangedObservable.unregisterObservers(this);
                this.subtitleCuesChangedObservable.unregisterObservers(this);
                this.volumeChangedObservable.unregisterObservers(this);
                this.eventBoundaryObservable.unregisterObservers(this);
                this.audioTrackChangedObservable.unregisterObservers(this);
                this.availableAudioTracksChangedObservable.unregisterObservers(this);
                this.availableThumbnailVariantsChangedObservable.unregisterObservers(this);
                this.telemetryObservable.unregisterObservers(this);
                this.telemetryUpdateObservable.unregisterObservers(this);
                this.httpRequestObservable.unregisterObservers(this);
                this.httpResponseObservable.unregisterObservers(this);
                this.endOfEventMarkerReceivedObservable.unregisterObservers(this);
                this.availableSubtitlesTracksChangedObservable.unregisterObservers(this);
                this.sessionEndedObservable.unregisterObservers(this);
                this.pinRequiredObservable.unregisterObservers(this);
                this.pinSuccessObservable.unregisterObservers(this);
                this.autoPlayPolicyPreventedPlaybackObservable.unregisterObservers(this);
                this.playoutDataObservable.unregisterObservers(this);
                this.playoutRulesObservable.unregisterObservers(this);
                this.assetMetadataUpdateObservable.unregisterObservers(this);
                this.audioTrackWillChangeObservable.unregisterObservers(this);
                this.pauseAdObservable.unregisterObservers(this);
                this.companionAdInsertionEnabledObservable.unregisterObservers(this);
                this.companionAdOpportunityStartedObservable.unregisterObservers(this);
                this.companionAdOpportunityEndedObservable.unregisterObservers(this);
                this.renderWatermarkObservable.unregisterObservers(this);
                this.clearWatermarkObservable.unregisterObservers(this);
                this.clearWatermarksObservable.unregisterObservers(this);
                this.bitrateChangedObservable.unregisterObservers(this);
                this.bitrateCapChangedObservable.unregisterObservers(this);
                this.bitrateCapRequestedObservable.unregisterObservers(this);
                this.ituQaSessionDataObservable.unregisterObservers(this);
                this.encodedFrameRateChangedObservable.unregisterObservers(this);
                this.renderedFrameRateChangedObservable.unregisterObservers(this);
                this.videoTrackChangedObservable.unregisterObservers(this);
                this.qualityFailoverObservable.unregisterObservers(this);
                this.cdnSwitchObservable.unregisterObservers(this);
                this.warningObservable.unregisterObservers(this);
                this.adBreakStartedObservable.unregisterObservers(this);
                this.adBreakFinishedObservable.unregisterObservers(this);
                this.adStartedObservable.unregisterObservers(this);
                this.adFinishedObservable.unregisterObservers(this);
                this.adBreakDataReceivedObservable.unregisterObservers(this);
                this.adTrackingReceivedObservable.unregisterObservers(this);
                this.catchupSeekObservable.unregisterObservers(this);
                this.adPositionObservable.unregisterObservers(this);
                this.errorObservable.unregisterObservers(this);
                this.manifestReceivedObservable.unregisterObservers(this);
                this.isMutedObservable.unregisterObservers(this);
                this.seekEndedObservable.unregisterObservers(this);
                this.seekStartedObservable.unregisterObservers(this);
                this.sessionStateObservable.unregisterObservers(this);
                this.sessionRetryStartedObservable.unregisterObservers(this);
                this.sessionRetryEndedObservable.unregisterObservers(this);
                this.sessionRestartStartedObservable.unregisterObservers(this);
                this.sessionRestartEndedObservable.unregisterObservers(this);
                this.timedMetadataReceivedObservable.unregisterObservers(this);
                this.bulkTimedMetadataReceivedObservable.unregisterObservers(this);
                this.playbackTimelineObservable.unregisterObservers(this);
                this.videoElementCreatedObservable.unregisterObservers(this);
                this.fullscreenChangedObservable.unregisterObservers(this);
                this.clickedObservable.unregisterObservers(this);
                this.rebufferStartObservable.unregisterObservers(this);
                this.rebufferEndObservable.unregisterObservers(this);
                this.playStartObservable.unregisterObservers(this);
            }
        },
        {
            key: "warnIfNoSession",
            value: function warnIfNoSession() {
                if (!this.sessionControllerInternal) {
                    this.logger.warn('No session controller currently attached');
                }
            }
        },
        {
            key: "flushStoredWarnings",
            value: function flushStoredWarnings() {
                var _this = this;
                if (this.sessionControllerInternal) {
                    var _this_warnings;
                    (_this_warnings = this.warnings) === null || _this_warnings === void 0 ? void 0 : _this_warnings.forEach(function(warning) {
                        var _this_sessionControllerInternal;
                        (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.notifyWarning(warning.errorCode, warning.reason);
                    });
                    this.warnings = [];
                }
            }
        },
        {
            key: "flushStoredAdBreaks",
            value: function flushStoredAdBreaks() {
                if (this.sessionControllerInternal && this.cachedAdBreaks) {
                    this.sessionControllerInternal.notifyAdBreakDataReceived(this.cachedAdBreaks);
                    this.cachedAdBreaks = null;
                }
            }
        },
        {
            key: "attachWaitForStateResolvers",
            value: function attachWaitForStateResolvers() {
                var _this = this;
                this.waitForStatePendingResolvers.forEach(function(pendingResolver) {
                    var _this_sessionControllerInternal_waitForState, _this_sessionControllerInternal;
                    (_this_sessionControllerInternal = _this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : (_this_sessionControllerInternal_waitForState = _this_sessionControllerInternal.waitForState(pendingResolver.state)) === null || _this_sessionControllerInternal_waitForState === void 0 ? void 0 : _this_sessionControllerInternal_waitForState.then(function() {
                        pendingResolver.resolver();
                    });
                });
                this.waitForStatePendingResolvers = [];
            }
        },
        {
            key: "attachSessionAdEvents",
            value: function attachSessionAdEvents() {
                var _this = this;
                var _this_sessionControllerInternal, _this_sessionControllerInternal1, _this_sessionControllerInternal2, _this_sessionControllerInternal3, _this_sessionControllerInternal4, _this_sessionControllerInternal5, _this_sessionControllerInternal6;
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.onAdBreakDataReceived(function(adBreaks) {
                    return _this.adBreakDataReceivedObservable.notifyObservers(adBreaks);
                });
                (_this_sessionControllerInternal1 = this.sessionControllerInternal) === null || _this_sessionControllerInternal1 === void 0 ? void 0 : _this_sessionControllerInternal1.onAdTrackingReceived(function(adBreaks) {
                    return _this.adTrackingReceivedObservable.notifyObservers(adBreaks);
                });
                (_this_sessionControllerInternal2 = this.sessionControllerInternal) === null || _this_sessionControllerInternal2 === void 0 ? void 0 : _this_sessionControllerInternal2.onAdBreakStarted(function(adBreak) {
                    return _this.adBreakStartedObservable.notifyObservers(adBreak);
                });
                (_this_sessionControllerInternal3 = this.sessionControllerInternal) === null || _this_sessionControllerInternal3 === void 0 ? void 0 : _this_sessionControllerInternal3.onAdBreakFinished(function(adBreak) {
                    return _this.adBreakFinishedObservable.notifyObservers(adBreak);
                });
                (_this_sessionControllerInternal4 = this.sessionControllerInternal) === null || _this_sessionControllerInternal4 === void 0 ? void 0 : _this_sessionControllerInternal4.onAdStarted(function(adData) {
                    return _this.adStartedObservable.notifyObservers(adData);
                });
                (_this_sessionControllerInternal5 = this.sessionControllerInternal) === null || _this_sessionControllerInternal5 === void 0 ? void 0 : _this_sessionControllerInternal5.onAdFinished(function(adData) {
                    return _this.adFinishedObservable.notifyObservers(adData);
                });
                (_this_sessionControllerInternal6 = this.sessionControllerInternal) === null || _this_sessionControllerInternal6 === void 0 ? void 0 : _this_sessionControllerInternal6.onAdPositionChanged(function(adPosition) {
                    return _this.adPositionObservable.notifyObservers(adPosition);
                });
            }
        },
        {
            key: "attachSessionEvents",
            value: // eslint-disable-next-line complexity -- Method is complex but easily readable. Splitting will not improve readability.
            function attachSessionEvents() {
                var _this = this;
                var _this_sessionControllerInternal, _this_sessionControllerInternal1, _this_sessionControllerInternal2, _this_sessionControllerInternal3, _this_sessionControllerInternal4, _this_sessionControllerInternal5, _this_sessionControllerInternal6, _this_sessionControllerInternal7, _this_sessionControllerInternal8, _this_sessionControllerInternal9, _this_sessionControllerInternal10, _this_sessionControllerInternal11, _this_sessionControllerInternal12, _this_sessionControllerInternal13, _this_sessionControllerInternal14, _this_sessionControllerInternal15, _this_sessionControllerInternal16, _this_sessionControllerInternal17, _this_sessionControllerInternal18, _this_sessionControllerInternal19, _this_sessionControllerInternal20, _this_sessionControllerInternal21, _this_sessionControllerInternal22, _this_sessionControllerInternal23, _this_sessionControllerInternal24, _this_sessionControllerInternal25, _this_sessionControllerInternal26, _this_sessionControllerInternal27, _this_sessionControllerInternal28, _this_sessionControllerInternal29, _this_sessionControllerInternal30, _this_sessionControllerInternal31, _this_sessionControllerInternal32, _this_sessionControllerInternal33, _this_sessionControllerInternal34, _this_sessionControllerInternal35, _this_sessionControllerInternal36, _this_sessionControllerInternal37, _this_sessionControllerInternal38, _this_sessionControllerInternal39, _this_sessionControllerInternal40, _this_sessionControllerInternal41, _this_sessionControllerInternal42, _this_sessionControllerInternal43, _this_sessionControllerInternal44, _this_sessionControllerInternal45, _this_sessionControllerInternal46, _this_sessionControllerInternal47, _this_sessionControllerInternal48, _this_sessionControllerInternal49, _this_sessionControllerInternal50, _this_sessionControllerInternal51, _this_sessionControllerInternal52;
                this.logger.verbose('Attaching session events');
                this.attachSessionAdEvents();
                (_this_sessionControllerInternal = this.sessionControllerInternal) === null || _this_sessionControllerInternal === void 0 ? void 0 : _this_sessionControllerInternal.onCatchupSeek(function(catchupSeek) {
                    return _this.catchupSeekObservable.notifyObservers(catchupSeek);
                });
                (_this_sessionControllerInternal1 = this.sessionControllerInternal) === null || _this_sessionControllerInternal1 === void 0 ? void 0 : _this_sessionControllerInternal1.onError(function(error) {
                    return _this.errorObservable.notifyObservers(error);
                });
                (_this_sessionControllerInternal2 = this.sessionControllerInternal) === null || _this_sessionControllerInternal2 === void 0 ? void 0 : _this_sessionControllerInternal2.onManifestReceived(function(manifestReceived) {
                    return _this.manifestReceivedObservable.notifyObservers(manifestReceived);
                });
                (_this_sessionControllerInternal3 = this.sessionControllerInternal) === null || _this_sessionControllerInternal3 === void 0 ? void 0 : _this_sessionControllerInternal3.onMuteChanged(function(isMuted) {
                    return _this.isMutedObservable.notifyObservers(isMuted);
                });
                (_this_sessionControllerInternal4 = this.sessionControllerInternal) === null || _this_sessionControllerInternal4 === void 0 ? void 0 : _this_sessionControllerInternal4.onSeekEnded(function(_, currentPosition) {
                    return _this.seekEndedObservable.notifyObservers(undefined, currentPosition);
                });
                (_this_sessionControllerInternal5 = this.sessionControllerInternal) === null || _this_sessionControllerInternal5 === void 0 ? void 0 : _this_sessionControllerInternal5.onSeekStarted(function(positionMs, currentPosition) {
                    return _this.seekStartedObservable.notifyObservers(positionMs, currentPosition);
                });
                (_this_sessionControllerInternal6 = this.sessionControllerInternal) === null || _this_sessionControllerInternal6 === void 0 ? void 0 : _this_sessionControllerInternal6.onStateChanged(function(state, currentPosition) {
                    return _this.sessionStateObservable.notifyObservers(state, currentPosition);
                });
                (_this_sessionControllerInternal7 = this.sessionControllerInternal) === null || _this_sessionControllerInternal7 === void 0 ? void 0 : _this_sessionControllerInternal7.onPlayStart(function(_, currentPosition) {
                    return _this.playStartObservable.notifyObservers(undefined, currentPosition);
                });
                (_this_sessionControllerInternal8 = this.sessionControllerInternal) === null || _this_sessionControllerInternal8 === void 0 ? void 0 : _this_sessionControllerInternal8.onRebufferStart(function(_, currentPosition) {
                    return _this.rebufferStartObservable.notifyObservers(undefined, currentPosition);
                });
                (_this_sessionControllerInternal9 = this.sessionControllerInternal) === null || _this_sessionControllerInternal9 === void 0 ? void 0 : _this_sessionControllerInternal9.onRebufferEnd(function(_, currentPosition) {
                    return _this.rebufferEndObservable.notifyObservers(undefined, currentPosition);
                });
                (_this_sessionControllerInternal10 = this.sessionControllerInternal) === null || _this_sessionControllerInternal10 === void 0 ? void 0 : _this_sessionControllerInternal10.onTimedMetadataReceived(function(metadata) {
                    return _this.timedMetadataReceivedObservable.notifyObservers(metadata);
                });
                (_this_sessionControllerInternal11 = this.sessionControllerInternal) === null || _this_sessionControllerInternal11 === void 0 ? void 0 : _this_sessionControllerInternal11.onBulkTimedMetadataReceived(function(metadatas) {
                    return _this.bulkTimedMetadataReceivedObservable.notifyObservers(metadatas);
                });
                (_this_sessionControllerInternal12 = this.sessionControllerInternal) === null || _this_sessionControllerInternal12 === void 0 ? void 0 : _this_sessionControllerInternal12.onPlaybackTimelineUpdated(function(playbackTimeline, currentPosition) {
                    return _this.playbackTimelineObservable.notifyObservers(playbackTimeline, currentPosition);
                });
                (_this_sessionControllerInternal13 = this.sessionControllerInternal) === null || _this_sessionControllerInternal13 === void 0 ? void 0 : _this_sessionControllerInternal13.onAudioTrackWillChange(function(trackId) {
                    return _this.audioTrackWillChangeObservable.notifyObservers(trackId);
                });
                (_this_sessionControllerInternal14 = this.sessionControllerInternal) === null || _this_sessionControllerInternal14 === void 0 ? void 0 : _this_sessionControllerInternal14.onBitrateChanged(function(bitrateLevel) {
                    return _this.bitrateChangedObservable.notifyObservers(bitrateLevel);
                });
                (_this_sessionControllerInternal15 = this.sessionControllerInternal) === null || _this_sessionControllerInternal15 === void 0 ? void 0 : _this_sessionControllerInternal15.onEncodedFrameRateChanged(function(frameRate) {
                    return _this.encodedFrameRateChangedObservable.notifyObservers(frameRate);
                });
                (_this_sessionControllerInternal16 = this.sessionControllerInternal) === null || _this_sessionControllerInternal16 === void 0 ? void 0 : _this_sessionControllerInternal16.onRenderedFrameRateChanged(function(frameRate) {
                    return _this.renderedFrameRateChangedObservable.notifyObservers(frameRate);
                });
                (_this_sessionControllerInternal17 = this.sessionControllerInternal) === null || _this_sessionControllerInternal17 === void 0 ? void 0 : _this_sessionControllerInternal17.onVideoTrackChanged(function(videoTrack) {
                    return _this.videoTrackChangedObservable.notifyObservers(videoTrack);
                });
                (_this_sessionControllerInternal18 = this.sessionControllerInternal) === null || _this_sessionControllerInternal18 === void 0 ? void 0 : _this_sessionControllerInternal18.onQualityFailover(function(videoFormat) {
                    return _this.qualityFailoverObservable.notifyObservers(videoFormat);
                });
                (_this_sessionControllerInternal19 = this.sessionControllerInternal) === null || _this_sessionControllerInternal19 === void 0 ? void 0 : _this_sessionControllerInternal19.onCdnSwitch(function(cdnSwitch) {
                    return _this.cdnSwitchObservable.notifyObservers(cdnSwitch);
                });
                (_this_sessionControllerInternal20 = this.sessionControllerInternal) === null || _this_sessionControllerInternal20 === void 0 ? void 0 : _this_sessionControllerInternal20.onWarning(function(error) {
                    return _this.warningObservable.notifyObservers(error);
                });
                (_this_sessionControllerInternal21 = this.sessionControllerInternal) === null || _this_sessionControllerInternal21 === void 0 ? void 0 : _this_sessionControllerInternal21.onPinRequired(function(cause) {
                    return _this.pinRequiredObservable.notifyObservers(cause);
                });
                (_this_sessionControllerInternal22 = this.sessionControllerInternal) === null || _this_sessionControllerInternal22 === void 0 ? void 0 : _this_sessionControllerInternal22.onPinSuccess(function() {
                    return _this.pinSuccessObservable.notifyObservers();
                });
                (_this_sessionControllerInternal23 = this.sessionControllerInternal) === null || _this_sessionControllerInternal23 === void 0 ? void 0 : _this_sessionControllerInternal23.onAutoPlayPolicyPreventedPlayback(function() {
                    return _this.autoPlayPolicyPreventedPlaybackObservable.notifyObservers();
                });
                (_this_sessionControllerInternal24 = this.sessionControllerInternal) === null || _this_sessionControllerInternal24 === void 0 ? void 0 : _this_sessionControllerInternal24.onPlayoutDataReceived(function(playoutData) {
                    return _this.playoutDataObservable.notifyObservers(playoutData);
                });
                (_this_sessionControllerInternal25 = this.sessionControllerInternal) === null || _this_sessionControllerInternal25 === void 0 ? void 0 : _this_sessionControllerInternal25.onPlayoutRulesReceived(function(playoutRules) {
                    return _this.playoutRulesObservable.notifyObservers(playoutRules);
                });
                (_this_sessionControllerInternal26 = this.sessionControllerInternal) === null || _this_sessionControllerInternal26 === void 0 ? void 0 : _this_sessionControllerInternal26.onAssetMetadataUpdated(function(metadata) {
                    return _this.assetMetadataUpdateObservable.notifyObservers(metadata);
                });
                (_this_sessionControllerInternal27 = this.sessionControllerInternal) === null || _this_sessionControllerInternal27 === void 0 ? void 0 : _this_sessionControllerInternal27.onAudioTrackChanged(function(trackId) {
                    return _this.audioTrackChangedObservable.notifyObservers(trackId);
                });
                (_this_sessionControllerInternal28 = this.sessionControllerInternal) === null || _this_sessionControllerInternal28 === void 0 ? void 0 : _this_sessionControllerInternal28.onBitrateCapChanged(function(bitrateCap) {
                    return _this.bitrateCapChangedObservable.notifyObservers(bitrateCap);
                });
                (_this_sessionControllerInternal29 = this.sessionControllerInternal) === null || _this_sessionControllerInternal29 === void 0 ? void 0 : _this_sessionControllerInternal29.onBitrateCapRequested(function(bitrateCap) {
                    return _this.bitrateCapRequestedObservable.notifyObservers(bitrateCap);
                });
                (_this_sessionControllerInternal30 = this.sessionControllerInternal) === null || _this_sessionControllerInternal30 === void 0 ? void 0 : _this_sessionControllerInternal30.onAvailableAudioTracksChanged(function(tracks) {
                    return _this.availableAudioTracksChangedObservable.notifyObservers(tracks);
                });
                (_this_sessionControllerInternal31 = this.sessionControllerInternal) === null || _this_sessionControllerInternal31 === void 0 ? void 0 : _this_sessionControllerInternal31.onAvailableSubtitlesTracksChanged(function(tracks) {
                    return _this.availableSubtitlesTracksChangedObservable.notifyObservers(tracks);
                });
                (_this_sessionControllerInternal32 = this.sessionControllerInternal) === null || _this_sessionControllerInternal32 === void 0 ? void 0 : _this_sessionControllerInternal32.onSessionEnded(function() {
                    return _this.sessionEndedObservable.notifyObservers();
                });
                (_this_sessionControllerInternal33 = this.sessionControllerInternal) === null || _this_sessionControllerInternal33 === void 0 ? void 0 : _this_sessionControllerInternal33.onStreamMetadataReceived(function(metadata) {
                    return _this.streamMetadataReceivedObservable.notifyObservers(metadata);
                });
                (_this_sessionControllerInternal34 = this.sessionControllerInternal) === null || _this_sessionControllerInternal34 === void 0 ? void 0 : _this_sessionControllerInternal34.onSubtitleCuesChanged(function(cues) {
                    return _this.subtitleCuesChangedObservable.notifyObservers(cues);
                });
                (_this_sessionControllerInternal35 = this.sessionControllerInternal) === null || _this_sessionControllerInternal35 === void 0 ? void 0 : _this_sessionControllerInternal35.onSubtitlesTrackChanged(function(track) {
                    return _this.subtitlesTrackChangedObservable.notifyObservers(track);
                });
                (_this_sessionControllerInternal36 = this.sessionControllerInternal) === null || _this_sessionControllerInternal36 === void 0 ? void 0 : _this_sessionControllerInternal36.onVolumeChanged(function(volume) {
                    return _this.volumeChangedObservable.notifyObservers(volume);
                });
                (_this_sessionControllerInternal37 = this.sessionControllerInternal) === null || _this_sessionControllerInternal37 === void 0 ? void 0 : _this_sessionControllerInternal37.onEventBoundary(function(eventBoundary) {
                    return _this.eventBoundaryObservable.notifyObservers(eventBoundary);
                });
                (_this_sessionControllerInternal38 = this.sessionControllerInternal) === null || _this_sessionControllerInternal38 === void 0 ? void 0 : _this_sessionControllerInternal38.onAvailableThumbnailVariantsChanged(function(thumbnailVariants) {
                    return _this.availableThumbnailVariantsChangedObservable.notifyObservers(thumbnailVariants);
                });
                (_this_sessionControllerInternal39 = this.sessionControllerInternal) === null || _this_sessionControllerInternal39 === void 0 ? void 0 : _this_sessionControllerInternal39.onEndOfEventMarkerReceived(function(eventTime) {
                    return _this.endOfEventMarkerReceivedObservable.notifyObservers(eventTime);
                });
                (_this_sessionControllerInternal40 = this.sessionControllerInternal) === null || _this_sessionControllerInternal40 === void 0 ? void 0 : _this_sessionControllerInternal40.onPauseAd(function(event) {
                    return _this.pauseAdObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal41 = this.sessionControllerInternal) === null || _this_sessionControllerInternal41 === void 0 ? void 0 : _this_sessionControllerInternal41.onVerifyCompanionAdInsertionEnabled(function(companionAdInsertionEnabled) {
                    return _this.companionAdInsertionEnabledObservable.notifyObservers(companionAdInsertionEnabled);
                });
                (_this_sessionControllerInternal42 = this.sessionControllerInternal) === null || _this_sessionControllerInternal42 === void 0 ? void 0 : _this_sessionControllerInternal42.onCompanionAdOpportunityStarted(function(event) {
                    return _this.companionAdOpportunityStartedObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal43 = this.sessionControllerInternal) === null || _this_sessionControllerInternal43 === void 0 ? void 0 : _this_sessionControllerInternal43.onCompanionAdOpportunityEnded(function(event) {
                    return _this.companionAdOpportunityEndedObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal44 = this.sessionControllerInternal) === null || _this_sessionControllerInternal44 === void 0 ? void 0 : _this_sessionControllerInternal44.onRenderWatermark(function(data) {
                    return _this.renderWatermarkObservable.notifyObservers(data);
                });
                (_this_sessionControllerInternal45 = this.sessionControllerInternal) === null || _this_sessionControllerInternal45 === void 0 ? void 0 : _this_sessionControllerInternal45.onClearWatermark(function(data) {
                    return _this.clearWatermarkObservable.notifyObservers(data);
                });
                (_this_sessionControllerInternal46 = this.sessionControllerInternal) === null || _this_sessionControllerInternal46 === void 0 ? void 0 : _this_sessionControllerInternal46.onClearWatermarks(function() {
                    return _this.clearWatermarksObservable.notifyObservers();
                });
                (_this_sessionControllerInternal47 = this.sessionControllerInternal) === null || _this_sessionControllerInternal47 === void 0 ? void 0 : _this_sessionControllerInternal47.onTelemetry(function(event) {
                    return _this.telemetryObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal48 = this.sessionControllerInternal) === null || _this_sessionControllerInternal48 === void 0 ? void 0 : _this_sessionControllerInternal48.onHttpRequest(function(event) {
                    return _this.httpRequestObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal49 = this.sessionControllerInternal) === null || _this_sessionControllerInternal49 === void 0 ? void 0 : _this_sessionControllerInternal49.onHttpResponse(function(event) {
                    return _this.httpResponseObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal50 = this.sessionControllerInternal) === null || _this_sessionControllerInternal50 === void 0 ? void 0 : _this_sessionControllerInternal50.onVideoElementCreated(function(event) {
                    return _this.videoElementCreatedObservable.notifyObservers(event);
                });
                (_this_sessionControllerInternal51 = this.sessionControllerInternal) === null || _this_sessionControllerInternal51 === void 0 ? void 0 : _this_sessionControllerInternal51.onFullscreenChanged(function(isFullscreen) {
                    return _this.fullscreenChangedObservable.notifyObservers(isFullscreen);
                });
                (_this_sessionControllerInternal52 = this.sessionControllerInternal) === null || _this_sessionControllerInternal52 === void 0 ? void 0 : _this_sessionControllerInternal52.onClicked(function() {
                    return _this.clickedObservable.notifyObservers();
                });
            }
        }
    ]);
    return SessionControllerInternalProxy;
}();

//# sourceMappingURL=session-controller-internal-proxy.js.map